// extracted by mini-css-extract-plugin
export default {"general_obv":"staff_general_obv__2hoxZ"};